import { Injectable } from '@angular/core';
import { extractFilename } from './report-download.helpers';

@Injectable({ providedIn: 'root' })
export class ReportDownloadService {
  /** Fetches the presigned report, then triggers a browser download as a blob. */
  public async download(
    presignedUrl: string,
    fallbackFileName: string
  ): Promise<void> {
    const response = await fetch(presignedUrl);
    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    try {
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = extractFilename(presignedUrl) ?? fallbackFileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } finally {
      window.URL.revokeObjectURL(objectUrl);
    }
  }
}
